var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9524 18.6191V23.4763C29.9524 25.5802 24.8783 28.3334 18.6191 28.3334C12.3598 28.3334 7.28572 25.5802 7.28572 23.4763C7.28572 22.7841 7.28572 21.4349 7.28572 19.4287",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76149 19.846C9.16164 21.7051 13.4929 23.4482 18.6191 23.4482C24.8783 23.4482 29.9524 20.8493 29.9524 18.6138C29.9524 17.3595 28.3547 15.9847 25.8465 15.0195",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0952 10.5234V15.3806C25.0952 17.4845 20.0211 20.2377 13.7619 20.2377C7.50268 20.2377 2.42857 17.4845 2.42857 15.3806C2.42857 14.3423 2.42857 11.5617 2.42857 10.5234",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7619 15.3538C20.0211 15.3538 25.0952 12.7548 25.0952 10.5194C25.0952 8.28397 20.0211 5.66602 13.7619 5.66602C7.50268 5.66602 2.42857 8.28397 2.42857 10.5194C2.42857 12.7548 7.50268 15.3538 13.7619 15.3538Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionAmount);
export default __webpack_public_path__ + "static/media/session-amount.69a48833e35377469235ba39aebbce93.svg";
export { ForwardRef as ReactComponent };